import React from "react";
import {Alert, AlertTitle} from "@material-ui/lab";
import {Snackbar} from "@material-ui/core";
import {useNotify} from "../../hooks/system/useNotify";


export const Notify = () => {
  const {current, onClose} = useNotify();

  return (
    <Snackbar open={!!current} autoHideDuration={5000} onClose={onClose} anchorOrigin={{horizontal: 'right', vertical: 'top'}}>
      <Alert onClose={onClose} severity={current?.variant}>
        <AlertTitle>{current?.title}</AlertTitle>
        {current?.message}
      </Alert>
    </Snackbar>
  )
}
